import { render, staticRenderFns } from "./submit-claim.component.vue?vue&type=template&id=54751aaa&"
import script from "./submit-claim.component.vue?vue&type=script&lang=ts&"
export * from "./submit-claim.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports